<template functional>
  <ul class="user-notifications-list">
    <slot />
  </ul>
</template>

<script>
  export default {
    name: 'UserNotificationsList'
  }
</script>

<style lang="scss" scoped>
  .user-notifications-list {
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    list-style: none;
  }
</style>
